import * as yup from 'yup';

export const schema = yup.object().shape({
  username: yup
    .string()
    .required('validation.requiredErrorLabel')
    .email('api.validation.invalidEmail'),
  password: yup.string().required('validation.requiredErrorLabel'),
});
